export default class Beneficiario {
    
    constructor(model = null){
        this.id = 0;
        this.empresaId = 0;
        this.nome = '';
        this.tipo = 0;
        this.tipoStr = '';
        this.cpfCnpj = '';
        this.identidadeInscricaoEstadual = '';
        this.cep = '';
        this.logradouro = '';
        this.bairro = '';
        this.cidade = '';
        this.estado = '';
        this.bairro = '';
        this.pais = '';
        this.telefone = '';
        this.celular = '';
        this.email = '';
        this.dataNascimentoFundacao = '';

        this.Pai = '';
        this.telefonePai = '';
        this.celularPai = '';
        this.emailPai = '';
        this.mae = '';
        this.telefoneMae = '';
        this.celularMae = '';
        this.emailMae = '';
        this.observacao = '';
        this.dataAdesao = '';

        this.sexo = '';
        this.sexoStr = '';
        this.naturalidade = '';
        this.nacionalidade = '';
        this.estadoCivil = '';
        this.estadoCivilStr = '';
        this.matricula = '';
        this.campo01 = '';
        this.campo02 = '';
        this.campo03 = '';
        this.campo04 = '';
        this.campo05 = '';
        this.campo06 = '';
        this.campo07 = '';
        this.campo08 = '';
        this.campo09 = '';
        this.campo10 = '';
        this.campo11 = '';
        this.campo12 = '';
        this.campo13 = '';
        this.campo14 = '';
        this.campo15 = '';

        this.etnia = 0;
        this.etniaStr = '';
        this.responsavel = '';
        this.parentescoResp = '';
        this.telefoneResp = '';
        this.celularResp = '';
        this.emailResp = '';
        this.cepResp = '';
        this.logradouroResp = '';
        this.bairroResp = '';
        this.cidadeResp = '';
        this.estadoResp = '';
        this.paisResp = '';

        //MAPA
        this.latitude = 0;
        this.longitude = 0;

        if (!model)
            return;
        
        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId;
        this.nome = model.nome;
        this.tipo = model.tipo;
        this.tipoStr = model.tipoStr;
        this.cpfCnpj = model.cpfCnpj;
        this.identidadeInscricaoEstadual = model.identidadeInscricaoEstadual;
        this.cep = model.cep;
        this.logradouro = model.logradouro;
        this.bairro = model.bairro;
        this.cidade = model.cidade;
        this.estado = model.estado;
        this.bairro = model.bairro;
        this.pais = model.pais;
        this.telefone = model.telefone;
        this.celular = model.celular;
        this.email = model.email;
        this.dataNascimentoFundacao = model.dataNascimentoFundacao == null ? null : new Date(model.dataNascimentoFundacao).yyyymmdd();

        this.pai = model.pai;
        this.telefonePai = model.telefonePai;
        this.celularPai = model.celularPai;
        this.emailPai = model.emailPai;
        this.mae = model.mae;
        this.telefoneMae = model.telefoneMae;
        this.celularMae = model.celularMae;
        this.emailMae = model.emailMae;
        this.observacao = model.observacao;
        this.dataAdesao = model.dataAdesao == null ? null : new Date(model.dataAdesao).yyyymmdd();

        this.sexo = model.sexo;
        this.sexoStr = model.sexoStr;
        this.naturalidade = model.naturalidade;
        this.nacionalidade = model.nacionalidade;
        this.estadoCivil = model.estadoCivil;
        this.estadoCivilStr = model.estadoCivilStr;
        this.matricula = model.matricula;
        this.campo01 = model.campo01;
        this.campo02 = model.campo02;
        this.campo03 = model.campo03;
        this.campo04 = model.campo04;
        this.campo05 = model.campo05;
        this.campo06 = model.campo06;
        this.campo07 = model.campo07;
        this.campo08 = model.campo08;
        this.campo09 = model.campo09;
        this.campo10 = model.campo10;
        this.campo11 = model.campo11;
        this.campo12 = model.campo12;
        this.campo13 = model.campo13;
        this.campo14 = model.campo14;
        this.campo15 = model.campo15;

        this.etnia = model.etnia;
        this.etniaStr = model.etniaStr;
        this.responsavel = model.responsavel;
        this.parentescoResp = model.parentescoResp;
        this.telefoneResp = model.telefoneResp;
        this.celularResp = model.celularResp;
        this.emailResp = model.emailResp;
        this.cepResp = model.cepResp;
        this.logradouroResp = model.logradouroResp;
        this.bairroResp = model.bairroResp;
        this.cidadeResp = model.cidadeResp;
        this.estadoResp = model.estadoResp;
        this.paisResp = model.paisResp;

        this.latitude = model.latitude;
        this.longitude = model.longitude;
    }
}